import { render, staticRenderFns } from "./AlertPop.vue?vue&type=template&id=7ddd00bb&scoped=true&"
import script from "./AlertPop.vue?vue&type=script&lang=js&"
export * from "./AlertPop.vue?vue&type=script&lang=js&"
import style0 from "./AlertPop.vue?vue&type=style&index=0&id=7ddd00bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd00bb",
  null
  
)

export default component.exports